import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { RumContext } from "../components/rum-provider";

// Deprecated - use RouteTracker in App.tsx instead
export function RecordPageView() {
  return null;
}

export function RecordPageViewWithoutUserId() {
  const location = useLocation();
  const rum = useContext(RumContext);
  const baseLocation = location.pathname.split('/');
  baseLocation.pop();
  const baseLocationPath = baseLocation.join('/')
  
  useEffect(() => {
    if (rum) {
      console.log(baseLocationPath);
      rum.recordPageView(baseLocationPath);
    }
  }, [baseLocationPath, rum]);
}

export function useRumClickEvent() {
  const rum = useContext(RumContext);
  
  return (eventName: string, eventDetail?: Record<string, any>) => {
    if (rum) {
      rum.recordEvent(eventName, {
        type: 'click',
        ...eventDetail
      });
    }
  };
}

// Helper hook for navigation events
export function useRumNavigationEvent() {
  const rum = useContext(RumContext);
  
  return (destination: string, eventDetail?: Record<string, any>) => {
    if (rum) {
      rum.recordEvent('navigation', {
        type: 'click',
        destination,
        ...eventDetail
      });
    }
  };
}
